<template>
  <div class="home-tiles-menu-item">
    <img :src="image" alt="" class="menu-image" />
    <div class="menu-title">
      {{ title }}
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeTilesMenuItem",
  props: {
    title: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="less">
@import "@/styles/_mixins";

.home-tiles-menu-item {
  max-width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  background: linear-gradient(180deg, #313944 0%, rgba(49, 57, 68, 0) 128.66%);
  opacity: 0.8;
  border: 1px solid rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(30px);
  border-radius: 15px;
  padding: 10px;

  &:hover {
    transform: scale(1.02);
    transition: transform 0.2s ease;
  }

  .menu-image {
    width: 100%;
    height: auto;
    border-radius: 10px;
    margin-bottom: 10px;
  }

  .menu-title {
    font-style: normal;
    font-weight: 500;
    font-size: 14.5px;
    line-height: 18px;
    color: #ffffff;
    text-align: center;
  }
}
</style>
